(function () {
  'use strict';

  // "You may also like" in the quick cart drawer, from Shopify's automatic
  // recommendations engine (intent=related). Seeded from the newest cart item, topped
  // up from the next ones, and rendered server side by sections/CWC_cart_recommendations.liquid.
  if (window.cwcCartRecsReady) return;
  window.cwcCartRecsReady = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Section Rendering API ids are lowercase — 'CWC_cart_recommendations' 404s
  const SECTION = 'cwc_cart_recommendations';
  let timer = null;
  let request = 0;

  function container() {
    return document.querySelector('[data-cwc-cart-recs]');
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  const MAX_RECS = 3;
  const MAX_SEEDS = 3;

  function fetchSection(url) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        return html ? new DOMParser().parseFromString(html, 'text/html') : null;
      })
      .catch(function () { return null; });
  }

  function recsUrl(productId) {
    return root + 'recommendations/products?product_id=' + encodeURIComponent(productId) +
      '&limit=10&intent=related&section_id=' + SECTION;
  }

  function fallbackUrl(handle) {
    return root + 'collections/' + encodeURIComponent(handle) + '?section_id=' + SECTION;
  }

  // Newest cart item first, then the next items, then the fallback collection — until there are 3
  function collect(urls) {
    const cards = [];
    const seen = {};
    let band = null;

    function next(index) {
      if (index >= urls.length || cards.length >= MAX_RECS) {
        return Promise.resolve({ band: band, cards: cards });
      }
      return fetchSection(urls[index]).then(function (doc) {
        if (doc) {
          if (!band) band = doc.querySelector('.cwc_cart-recs__band');
          doc.querySelectorAll('.cwc_cart-recs__card').forEach(function (card) {
            const id = card.dataset.productId;
            if (cards.length >= MAX_RECS || seen[id]) return;
            seen[id] = true;
            cards.push(card);
          });
        }
        return next(index + 1);
      });
    }

    return next(0);
  }

  // The drawer fires several DOM changes per cart update, so load() runs more than
  // once per cart. Only a different cart starts a new fetch; a repeat check never
  // cancels the fetch already running for the same cart.
  let pendingKey = null;

  function render(result) {
    const target = container();
    if (!target) return;
    if (!result.band || !result.cards.length) {
      target.textContent = '';
      return;
    }
    const band = document.importNode(result.band, true);
    const list = band.querySelector('.cwc_cart-recs__list');
    if (list) {
      list.replaceChildren.apply(list, result.cards.map(function (card) {
        return document.importNode(card, true);
      }));
    }
    target.replaceChildren(band);
  }

  function load() {
    if (!container()) return;

    getCart()
      .then(function (cart) {
        const target = container();
        if (!target) return;

        if (!cart.items || !cart.items.length) {
          target.textContent = '';
          target.dataset.key = '';
          pendingKey = null;
          return;
        }

        const key = cart.items.map(function (item) { return item.product_id; }).join(',');
        if (key === pendingKey || (key === target.dataset.key && target.childElementCount)) return;

        pendingKey = key;
        const id = ++request;
        const seeds = [];
        cart.items.forEach(function (item) {
          if (seeds.length < MAX_SEEDS && seeds.indexOf(item.product_id) === -1) seeds.push(item.product_id);
        });
        const urls = seeds.map(recsUrl);
        if (target.dataset.fallbackCollection) urls.push(fallbackUrl(target.dataset.fallbackCollection));

        return collect(urls).then(function (result) {
          if (id !== request) return; // a newer cart has taken over
          pendingKey = null;
          const current = container();
          if (current) current.dataset.key = key;
          render(result);
          // Where each card came from: Shopify's recommendations engine or the fallback collection
          const sources = result.cards.map(function (card) { return card.dataset.recSource; });
          if (window.console && sources.length) {
            console.info('[CWC cart recs] ' + sources.filter(function (s) { return s === 'recommended'; }).length +
              ' recommended, ' + sources.filter(function (s) { return s === 'fallback'; }).length + ' from fallback collection');
          }
        });
      })
      .catch(function () {
        pendingKey = null;
      });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(load, 150);
  }

  function refreshDrawer(cart) {
    if (window.theme) window.theme.cartData = cart;
    if (typeof window.emit === 'function') window.emit('cart:updated', { cart: cart });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    // The quick cart re-renders itself on this event
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
  }

  // Single-variant products add straight from the list
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cwc-recs-add]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    button.classList.add('cwc_cart-recs__button--loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(button.dataset.cwcRecsAdd, 10), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return getCart();
      })
      .then(refreshDrawer)
      .catch(function () {
        button.disabled = false;
        button.classList.remove('cwc_cart-recs__button--loading');
      });
  });

  // The drawer swaps its items in place on every cart change, and rebuilds its
  // whole body when going from empty to filled — either way, check again.
  function watch() {
    const drawer = document.querySelector('.quick-cart');
    if (drawer) {
      new MutationObserver(function (mutations) {
        const target = container();
        const onlyOurs = mutations.every(function (m) { return target && target.contains(m.target); });
        if (!onlyOurs) schedule();
      }).observe(drawer, { childList: true, subtree: true });
    }
    document.addEventListener('cart:updated', schedule);
    load();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
